import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Company } from '../models/Company';
import { CompanyService } from '../services/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { map, switchMap } from 'rxjs/internal/operators';
import { of, Subscription } from 'rxjs';
import { Aggregate } from '../../account/models/Aggregate';
import { Address } from '../../account/models/Address';
import { BalancingProcessDetails } from '../../account/models/BalancingProcessDetails';
import { AddressService } from '../../shared/services/address.service';
import { CountyDTO } from '../../shared/models/CountyDTO';
import { CityDTO } from '../../shared/models/CityDTO';
import { DatePipe } from '@angular/common';
import { InternalDocument } from '../../../shared/model/internal-document';
import { DocumentService } from '../../../shared/service/document.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-company-data',
  templateUrl: './view-company-data.component.html',
  styleUrls: ['./view-company-data.component.scss']
})
export class ViewCompanyDataComponent implements OnInit, OnDestroy {

  // @Input() isContractChange: boolean;
  // @Input() fromSupplier: boolean;
  // @Input() isFormSubmitAttempt: boolean;

  @Input() set clientId(clientId: number) {
    if (!clientId) {
      return;
    }

    this.companyDetailsService.getCompanyDetails(clientId)
      .subscribe((companyDetails: Company) => this.initializeFormFields(companyDetails));
  }
  // @Input() set isEditable(value: boolean) {
  //   this.editable = value;
  //   if (!this.editable) {
  //     this.accountForm.disable();
  //   }
  // }
  @Input() set company(value: Company) {
    if (!value) {
      return;
    }

    const aggregate: Aggregate = value.aggregateDTO;
    const balancingProcessDetails: BalancingProcessDetails = value.balancingProcessDetailsDTO;
    const address: Address = value.addressDTO;
    const correspondenceAddress: Address = value.correspondenceAddressDTO;

    this.accountForm.patchValue({
      code: value.code,
      number: [''],
      name: value.name,
      creationDate: [''],
      phoneNumber: value.phoneNumber,
      mobileNumber: value.mobileNumber,
      fax: value.fax,
      cui: value.cui,
      onrcRegistrationNumber: value.onrcRegistrationNumber,
      email: value.email,
      legalForm: value.legalForm,
      clientType: 'Non-Casnic',
      position: '',
      // address
      county: address.county,
      city: address.city,
      streetName: address.streetName,
      streetNumber: address.streetNumber,
      block: address.block,
      apartment: address.apartment,
      floor: address.floor,
      extendedAddress: address.extendedAddress,
      postalCode: address.postalCode,
      // correspondenceAddress
      correspondenceCounty: correspondenceAddress.county,
      correspondenceCity: correspondenceAddress.city,
      correspondenceStreetName: correspondenceAddress.streetName,
      correspondenceStreetNumber: correspondenceAddress.streetNumber,
      correspondenceBlock: correspondenceAddress.block,
      correspondenceFloor: correspondenceAddress.floor,
      correspondenceApartment: correspondenceAddress.apartment,
      correspondenceExtendedAddress: correspondenceAddress.extendedAddress,
      correspondencePostalCode: correspondenceAddress.postalCode,
      // aggregate
      aggregationName: aggregate.aggregationName,
      aggregationJuridicalForm: aggregate.aggregationJuridicalForm,
      aggregationCui: aggregate.aggregationCui,
      aggregationOnrcRegistrationNumber: aggregate.aggregationOnrcRegistrationNumber,
      aggregationPhoneNumber: aggregate.aggregationPhoneNumber,
      aggregationMobilePhoneNumber: aggregate.aggregationMobilePhoneNumber,
      aggregationFax: aggregate.aggregationFax,
      aggregationEmail: aggregate.aggregationEmail,
      aggregationPersonName: aggregate.aggregationPersonName,
      aggregationPersonSurname: aggregate.aggregationPersonSurname,
      aggregationPersonCnp: aggregate.aggregationPersonCnp,
      aggregatorClientType: aggregate.aggregatorClientType,
      balancingProcessName: balancingProcessDetails.name,
      balancingProcessJuridicalForm: balancingProcessDetails.juridicalForm,
      balancingProcessCui: balancingProcessDetails.cui,
      balancingProcessRegistrationNumber: balancingProcessDetails.registrationNumber,
      balancingProcessPhoneNumber: balancingProcessDetails.phoneNumber,
      balancingProcessMobilePhoneNumber: balancingProcessDetails.mobilePhoneNumber,
      balancingProcessFax: balancingProcessDetails.fax,
      balancingProcessEmail: balancingProcessDetails.email,
      balancingProcessHasDelegatedPRE: balancingProcessDetails.hasDelegatedPRE,
      balancingProcessHasOtherPRE: balancingProcessDetails.hasOtherPRE,
      balancingProcessPersonName: balancingProcessDetails.personName,
      balancingProcessPersonSurname: balancingProcessDetails.personSurname,
      balancingProcessPersonCnp: balancingProcessDetails.personCnp,
      balancingProcessPreType: balancingProcessDetails.preType,
    });
    this.companyId = value.id;
    this.documents = value.documents != null ? value.documents : [];
    this.setIsElectricalEnergyClient();

    this.cities = [];
    this.citiesCorrespondence = [];

    this.addressService.getCities(this.accountForm.get('county').value)
      .subscribe((cities: CityDTO[]) => {
        this.cities = cities;
      });
    this.addressService.getCities(this.accountForm.get('correspondenceCounty').value)
      .subscribe(citiesCorrespondence => {
        this.citiesCorrespondence = citiesCorrespondence;
      });
  }

  public accountForm: FormGroup;
  public permissionForm: FormGroup;
  public companyDetails: any;
  public companyId: number;
  public routeDataSub: Subscription;
  public isSameAddress = false;
  public editable = true;
  public documents: InternalDocument[] = [];
  public counties: CountyDTO[] = [];
  public cities: CityDTO[] = [];
  public citiesCorrespondence: CityDTO[] = [];
  public settings = {

    columns: {
      img: {
        title: 'Image',
        type: 'html',
      },
      file_name: {
        title: 'File Name'
      },
      url: {
        title: 'Url',
      },
    },
  };
  private subscriptions: Subscription[] = [];

  constructor(
    private formBuilder: FormBuilder,
    public documentService: DocumentService,
    private companyDetailsService: CompanyService,
    private route: ActivatedRoute,
    private router: Router,
    private addressService: AddressService,
    private datepipe: DatePipe,
    private toastrService: ToastrService,
  ) {
    this.editable = false;
    this.createAccountForm();
    this.createAccountFormListeners();
    this.createPermissionForm();
  }

  createAccountForm(): void {
    this.accountForm = this.formBuilder.group({
      code: [''],
      number: [''],
      name: ['', [Validators.required]],
      creationDate: [''],
      phoneNumber: [''],
      mobileNumber: [''],
      fax: [''],
      cui: ['', [Validators.required]],
      onrcRegistrationNumber: ['', [Validators.required]],
      email: [''],
      legalForm: ['', [Validators.required]],
      clientType: ['Non-Casnic', [Validators.required]],
      position: ['', [Validators.required]],
      // address
      county: ['', [Validators.required]],
      city: ['', [Validators.required]],
      streetName: ['', [Validators.required]],
      streetNumber: ['', [Validators.required]],
      block: [''],
      apartment: [''],
      floor: [''],
      extendedAddress: [''],
      postalCode: ['', [Validators.required]],
      // correspondenceAddress
      correspondenceCounty: ['', [Validators.required]],
      correspondenceCity: ['', [Validators.required]],
      correspondenceStreetName: ['', [Validators.required]],
      correspondenceStreetNumber: ['', [Validators.required]],
      correspondenceBlock: [''],
      correspondenceFloor: [''],
      correspondenceApartment: [''],
      correspondenceExtendedAddress: [''],
      correspondencePostalCode: ['', [Validators.required]],
      // aggregationDetails
      aggregationPersonName: [{ value: '', disabled: true }, [Validators.required]],
      aggregationPersonSurname: [{ value: '', disabled: true }, [Validators.required]],
      aggregationPersonCnp: [{ value: '', disabled: true }, [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
      aggregatorClientType: [{ value: '', disabled: true }, [Validators.required]],
      //
      aggregationName: [''],
      aggregationJuridicalForm: [''],
      aggregationCui: [''],
      aggregationOnrcRegistrationNumber: [''],
      aggregationPhoneNumber: [''],
      aggregationMobilePhoneNumber: [''],
      aggregationFax: [''],
      aggregationEmail: [''],
      isProsumer: [''],
      isSelfSupplier: [''],
      isAggregate: [''],
      isElectricalEnergyClient: [''],
      sameAddress: [''],
      // balancingProcessDetails
      balancingProcessName: [''],
      balancingProcessJuridicalForm: [''],
      balancingProcessCui: [''],
      balancingProcessRegistrationNumber: [''],
      balancingProcessPhoneNumber: [''],
      balancingProcessMobilePhoneNumber: [''],
      balancingProcessFax: [''],
      balancingProcessEmail: [''],
      balancingProcessHasDelegatedPRE: [''],
      balancingProcessHasOtherPRE: [''],
      // balancingProcessDetails
      balancingProcessPersonName: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessPersonSurname: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessPersonCnp: [{ value: '', disabled: true }, [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
      balancingProcessPreType: [{ value: '', disabled: true }, [Validators.required]],
      documents: this.documents
    });

    this.accountForm.disable();
  }

  createAccountFormListeners(): void {
    this.subscriptions.push(
      this.accountForm.get('county').valueChanges.subscribe(value => this.updateCorrespondenceCounty(value))
    );
    this.subscriptions.push(
      this.accountForm.get('city').valueChanges.subscribe(value => this.updateCorrespondenceCity(value))
    );
    this.subscriptions.push(
      this.accountForm.get('streetName').valueChanges.subscribe(value => this.updateCorrespondenceStreetName(value))
    );
    this.subscriptions.push(
      this.accountForm.get('streetNumber').valueChanges.subscribe(value => this.updateCorrespondenceStreetNumber(value))
    );
    this.subscriptions.push(
      this.accountForm.get('block').valueChanges.subscribe(value => this.updateCorrespondenceBlock(value))
    );
    this.subscriptions.push(
      this.accountForm.get('apartment').valueChanges.subscribe(value => this.updateCorrespondenceApartment(value))
    );
    this.subscriptions.push(
      this.accountForm.get('floor').valueChanges.subscribe(value => this.updateCorrespondenceFloor(value))
    );
    this.subscriptions.push(
      this.accountForm.get('extendedAddress').valueChanges.subscribe(value => this.updateCorrespondenceExtendedAddress(value))
    );
    this.subscriptions.push(
      this.accountForm.get('postalCode').valueChanges.subscribe(value => this.updateCorrespondencePostalCode(value))
    );
  }

  createPermissionForm(): void {
    this.permissionForm = this.formBuilder.group({});
  }

  ngOnInit(): void {
    /*this.routeDataSub = this.route
      .paramMap
      .pipe(
        map(value => {
          if (window.history.state.editable != null) {
            this.editable = !!window.history.state.editable;
            if (!this.editable) {
              this.accountForm.disable();
            }
          }
          if (window.history.state.clientId != null) {
            this.clientId = +window.history.state.clientId;
          }
          return this.clientId;
        }),
        switchMap(
          clientId => (clientId && !this.isContractChange)
            ? this.companyDetailsService.getCompanyDetails(clientId) : of(null)
        )
      ).subscribe((companyDetails: Company) => this.initializeFormFields(companyDetails));*/
    this.addressService.getCounties().subscribe(counties => {
      this.counties = counties;
    });
  }

  setIsElectricalEnergyClient(): void {
    const isElectricalEnergyClient = this.accountForm.value.isElectricalEnergyClient;
    this.accountForm.controls.isElectricalEnergyClient.setValue(isElectricalEnergyClient);
    const isAggregate = isElectricalEnergyClient && this.accountForm.value.isAggregate;
    const hasDelegatedPRE = isElectricalEnergyClient && this.accountForm.value.balancingProcessHasDelegatedPRE;
    const hasOtherPRE = isElectricalEnergyClient && this.accountForm.value.balancingProcessHasOtherPRE;
    this.setIsAggregate(isAggregate);
    this.hasBalanceProcessDetails(isElectricalEnergyClient);
    this.setHasDelegatedPRE(hasDelegatedPRE);
    this.setHasOtherPRE(hasOtherPRE);
  }

  initializeFormFields(companyDetails: Company): void {
    if (companyDetails) {
      const {
        email,
        phoneNumber,
        mobileNumber,
        onrcRegistrationNumber,
        isProsumer,
        isSelfSupplier,
        isAggregate,
        isElectricalEnergyClient,
        creationDate,
        code,
        cui,
        name,
        fax,
        position,
        legalForm,
        addressDTO,
        correspondenceAddressDTO,
        aggregateDTO,
        balancingProcessDetailsDTO,
        documents
      }
        = companyDetails;

      this.companyDetails = {
        ...aggregateDTO,
        ...addressDTO,
        ...balancingProcessDetailsDTO,
        email,
        phoneNumber,
        code,
        name,
        fax,
        legalForm,
        cui,
        position,
        mobileNumber,
        isProsumer,
        isAggregate,
        isSelfSupplier,
        isElectricalEnergyClient,
        creationDate,
        onrcRegistrationNumber
      };
      this.companyId = companyDetails.id;
      this.documents = documents != null ? documents : [];
      Object.keys(this.accountForm.controls).forEach(
        key => {
          if (this.companyDetails[key]) {
            this.accountForm.controls[key].setValue(this.companyDetails[key]);
          }
        }
      );

      this.accountForm.patchValue({
        correspondenceCounty: correspondenceAddressDTO.county,
        correspondenceCity: correspondenceAddressDTO.city,
        correspondenceStreetName: correspondenceAddressDTO.streetName,
        correspondenceStreetNumber: correspondenceAddressDTO.streetNumber,
        correspondenceBlock: correspondenceAddressDTO.block,
        correspondenceFloor: correspondenceAddressDTO.floor,
        correspondenceApartment: correspondenceAddressDTO.apartment,
        correspondencePostalCode: correspondenceAddressDTO.postalCode,
        balancingProcessName: balancingProcessDetailsDTO.name,
        balancingProcessJuridicalForm: balancingProcessDetailsDTO.juridicalForm,
        balancingProcessCui: balancingProcessDetailsDTO.cui,
        balancingProcessRegistrationNumber: balancingProcessDetailsDTO.registrationNumber,
        balancingProcessPhoneNumber: balancingProcessDetailsDTO.phoneNumber,
        balancingProcessMobilePhoneNumber: balancingProcessDetailsDTO.mobilePhoneNumber,
        balancingProcessFax: balancingProcessDetailsDTO.fax,
        balancingProcessEmail: balancingProcessDetailsDTO.email,
        balancingProcessHasDelegatedPRE: balancingProcessDetailsDTO.hasDelegatedPRE,
        balancingProcessHasOtherPRE: balancingProcessDetailsDTO.hasOtherPRE,
        balancingProcessPersonName: balancingProcessDetailsDTO.personName,
        balancingProcessPersonSurname: balancingProcessDetailsDTO.personSurname,
        balancingProcessPersonCnp: balancingProcessDetailsDTO.personCnp,
        balancingProcessPreType: balancingProcessDetailsDTO.preType
      });

      this.setIsElectricalEnergyClient();

      this.cities = [];
      this.citiesCorrespondence = [];

      this.addressService.getCities(this.accountForm.get('county').value)
        .subscribe((cities: CityDTO[]) => {
          this.cities = cities;
        });
      this.addressService.getCities(this.accountForm.get('correspondenceCounty').value)
        .subscribe((citiesCorrespondence: CityDTO[]) => {
          this.citiesCorrespondence = citiesCorrespondence;
        });

      if (!this.editable) {
        this.accountForm.disable();
      }
    }
  }

  toggleSameAddress(): void {
    this.isSameAddress = !this.isSameAddress;

    if (this.isSameAddress) {
      this.citiesCorrespondence = [];
      this.addressService.getCities(this.accountForm.get('county').value).subscribe(data => {
        this.citiesCorrespondence = data;
      });
      const formData = this.accountForm.value;
      this.accountForm.patchValue({
        correspondenceCounty: formData.county,
        correspondenceCity: formData.city,
        correspondenceStreetName: formData.streetName,
        correspondenceStreetNumber: formData.streetNumber,
        correspondenceBlock: formData.block,
        correspondenceFloor: formData.floor,
        correspondenceApartment: formData.apartment,
        correspondenceExtendedAddress: formData.extendedAddress,
        correspondencePostalCode: formData.postalCode,
      });
      this.accountForm.controls.correspondenceStreetName.disable();
      this.accountForm.controls.correspondenceStreetNumber.disable();
      this.accountForm.controls.correspondenceApartment.disable();
      this.accountForm.controls.correspondenceBlock.disable();
      this.accountForm.controls.correspondenceFloor.disable();
      this.accountForm.controls.correspondencePostalCode.disable();
      this.accountForm.controls.correspondenceCounty.disable();
      this.accountForm.controls.correspondenceCity.disable();
    } else {
      this.accountForm.controls.correspondenceStreetName.enable();
      this.accountForm.controls.correspondenceStreetNumber.enable();
      this.accountForm.controls.correspondenceApartment.enable();
      this.accountForm.controls.correspondenceBlock.enable();
      this.accountForm.controls.correspondenceFloor.enable();
      this.accountForm.controls.correspondencePostalCode.enable();
      this.accountForm.controls.correspondenceCounty.enable();
      this.accountForm.controls.correspondenceCity.enable();
    }
  }

  setHasOtherPRE(value: boolean): void {
    this.accountForm.controls.balancingProcessHasOtherPRE.setValue(value);
    if (value === true) {
      this.accountForm.controls.balancingProcessPreType.enable();
      if (this.accountForm.controls.balancingProcessPreType.value === 'PERSOANA_JURIDICA') {
        this.enableBalancingPJPre();
      } else if (this.accountForm.controls.balancingProcessPreType.value === 'PERSOANA_FIZICA') {
        this.enableBalancingPFPre();
      }
    } else {
      if (!this.accountForm.value.balancingProcessHasDelegatedPRE) {
        this.accountForm.controls.balancingProcessPreType.disable();
        this.disableBalancingPJPre();
        this.disableBalancingPFPre();
      }
    }
  }

  disableBalancingPFPre(): void {
    this.accountForm.controls.balancingProcessName.disable();
    this.accountForm.controls.balancingProcessJuridicalForm.disable();
    this.accountForm.controls.balancingProcessCui.disable();
    this.accountForm.controls.balancingProcessRegistrationNumber.disable();
    this.accountForm.controls.balancingProcessPhoneNumber.disable();
    this.accountForm.controls.balancingProcessMobilePhoneNumber.disable();
    this.accountForm.controls.balancingProcessFax.disable();
    this.accountForm.controls.balancingProcessEmail.disable();
  }

  disableBalancingPJPre(): void {
    this.accountForm.controls.balancingProcessPersonName.disable();
    this.accountForm.controls.balancingProcessPersonSurname.disable();
    this.accountForm.controls.balancingProcessPersonCnp.disable();
  }

  enableBalancingPJPre(): void {
    this.accountForm.controls.balancingProcessName.enable();
    this.accountForm.controls.balancingProcessJuridicalForm.enable();
    this.accountForm.controls.balancingProcessCui.enable();
    this.accountForm.controls.balancingProcessRegistrationNumber.enable();
    this.accountForm.controls.balancingProcessPhoneNumber.enable();
    this.accountForm.controls.balancingProcessMobilePhoneNumber.enable();
    this.accountForm.controls.balancingProcessFax.enable();
    this.accountForm.controls.balancingProcessEmail.enable();
  }

  enablePFAggregator(): void {
    this.accountForm.controls.aggregationPersonName.enable();
    this.accountForm.controls.aggregationPersonSurname.enable();
    this.accountForm.controls.aggregationPersonCnp.enable();
  }

  disablePJAggregator(): void {
    this.accountForm.controls.aggregationPersonName.disable();
    this.accountForm.controls.aggregationPersonSurname.disable();
    this.accountForm.controls.aggregationPersonCnp.disable();
  }

  enablePJAggregator(): void {
    this.accountForm.controls.aggregationName.enable();
    this.accountForm.controls.aggregationJuridicalForm.enable();
    this.accountForm.controls.aggregationCui.enable();
    this.accountForm.controls.aggregationOnrcRegistrationNumber.enable();
    this.accountForm.controls.aggregationPhoneNumber.enable();
    this.accountForm.controls.aggregationMobilePhoneNumber.enable();
    this.accountForm.controls.aggregationFax.enable();
    this.accountForm.controls.aggregationEmail.enable();
  }

  disablePFAggregator(): void {
    this.accountForm.controls.aggregationName.disable();
    this.accountForm.controls.aggregationJuridicalForm.disable();
    this.accountForm.controls.aggregationCui.disable();
    this.accountForm.controls.aggregationOnrcRegistrationNumber.disable();
    this.accountForm.controls.aggregationPhoneNumber.disable();
    this.accountForm.controls.aggregationMobilePhoneNumber.disable();
    this.accountForm.controls.aggregationFax.disable();
    this.accountForm.controls.aggregationEmail.disable();
  }

  onBalancingProcessPreType(value: string): void {
    if (this.accountForm.controls.balancingProcessPreType.disabled) {
      this.accountForm.controls.balancingProcessPreType.enable();
    }
    if (value === "Persoana fizica") {
      this.enableBalancingPFPre();
      this.disableBalancingPFPre();
      this.accountForm.controls.balancingProcessPreType.setValue("PERSOANA_FIZICA");
    } else if (value === "Persoana juridica") {
      this.disableBalancingPJPre();
      this.enableBalancingPJPre();
      this.accountForm.controls.balancingProcessPreType.setValue("PERSOANA_JURIDICA");
    }
  }

  onAggregatorType(value: string): void {
    if (this.accountForm.controls.aggregatorClientType.disabled) {
      this.accountForm.controls.aggregatorClientType.enable();
    }
    if (value === "Persoana fizica") {
      this.enablePFAggregator();
      this.disablePFAggregator();
      this.accountForm.controls.aggregatorClientType.setValue("PERSOANA_FIZICA");
    } else if (value === "Persoana juridica") {
      this.disablePJAggregator();
      this.enablePJAggregator();
      this.accountForm.controls.aggregatorClientType.setValue("PERSOANA_JURIDICA");
    }
  }

  checkDate(e) {
    console.log(e.target.value);
  }

  setIsSelfSupplier(val: boolean): void {
    this.accountForm.controls.isSelfSupplier.setValue(val);
  }

  setIsProsumer(val: boolean): void {
    this.accountForm.controls.isProsumer.setValue(val);
  }

  setHasDelegatedPRE(value: boolean): void {
    this.accountForm.controls.balancingProcessHasDelegatedPRE.setValue(value);
    if (value === true) {
      this.accountForm.controls.balancingProcessPreType.enable();
      if (this.accountForm.controls.balancingProcessPreType.value === "PERSOANA_JURIDICA") {
        this.enableBalancingPJPre();
      } else if (this.accountForm.controls.balancingProcessPreType.value === "PERSOANA_FIZICA") {
        this.enableBalancingPFPre();
      }
    } else {
      if (!this.accountForm.value.balancingProcessHasOtherPRE) {
        this.accountForm.controls.balancingProcessPreType.disable();
        this.disableBalancingPJPre();
        this.disableBalancingPFPre();
      }
    }
  }

  onChangeCounty(): void {
    this.cities = [];
    if (this.isSameAddress) {
      this.citiesCorrespondence = [];
    }
    this.addressService.getCities(this.accountForm.get('county').value).subscribe((cities: CityDTO[]) => {
      this.cities = cities;
      if (this.isSameAddress) {
        this.citiesCorrespondence = cities;
      }
    });
  }

  enableBalancingPFPre(): void {
    this.accountForm.controls.balancingProcessPersonName.enable();
    this.accountForm.controls.balancingProcessPersonSurname.enable();
    this.accountForm.controls.balancingProcessPersonCnp.enable();
  }

  onChangeCountyCorrespondence(): void {
    this.citiesCorrespondence = [];
    this.addressService.getCities(this.accountForm.get('correspondenceCounty').value).subscribe(citiesCorrespondence => {
      this.citiesCorrespondence = citiesCorrespondence;
    });
  }

  hasBalanceProcessDetails(val: boolean): void {
    if (!val) {
      this.accountForm.controls.balancingProcessPersonName.disable();
      this.accountForm.controls.balancingProcessPersonSurname.disable();
      this.accountForm.controls.balancingProcessPersonCnp.disable();
      this.accountForm.controls.balancingProcessName.disable();
      this.accountForm.controls.balancingProcessJuridicalForm.disable();
      this.accountForm.controls.balancingProcessCui.disable();
      this.accountForm.controls.balancingProcessRegistrationNumber.disable();
      this.accountForm.controls.balancingProcessPhoneNumber.disable();
      this.accountForm.controls.balancingProcessMobilePhoneNumber.disable();
      this.accountForm.controls.balancingProcessFax.disable();
      this.accountForm.controls.balancingProcessEmail.disable();
    }
  }

  setIsAggregate(value: boolean): void {
    this.accountForm.controls.isAggregate.setValue(value);
    if (value === true) {
      this.accountForm.controls.aggregatorClientType.enable();
      if (this.accountForm.controls.aggregatorClientType.value === "PERSOANA_FIZICA") {
        this.enablePFAggregator();
      } else if (this.accountForm.controls.aggregatorClientType.value === "PERSOANA_JURIDICA") {
        this.enablePJAggregator();
      }
    } else {
      this.accountForm.controls.aggregatorClientType.disable();
      this.disablePFAggregator();
      this.disablePJAggregator();
    }
  }

  createDataFromForm(): Company {
    const formValue = this.accountForm.getRawValue();

    const aggregateDTO: Aggregate = {
      aggregationName: formValue.aggregationName,
      aggregationPhoneNumber: formValue.aggregationPhoneNumber,
      aggregationFax: formValue.aggregationFax,
      aggregationCui: formValue.aggregationCui,
      aggregationEmail: formValue.aggregationEmail,
      aggregationJuridicalForm: formValue.aggregationJuridicalForm,
      aggregationOnrcRegistrationNumber: formValue.aggregationOnrcRegistrationNumber,
      aggregationMobilePhoneNumber: formValue.aggregationMobilePhoneNumber,
      aggregationPersonName: formValue.aggregationPersonName,
      aggregationPersonSurname: formValue.aggregationPersonSurname,
      aggregationPersonCnp: formValue.aggregationPersonCnp,
      aggregatorClientType: formValue.aggregatorClientType
    };

    const addressDTO: Address = {
      city: formValue.city,
      extendedAddress: formValue.extendedAddress,
      postalCode: formValue.postalCode,
      county: formValue.county,
      streetNumber: formValue.streetNumber,
      streetName: formValue.streetName,
      block: formValue.block,
      floor: formValue.floor,
      apartment: formValue.apartment
    };

    const balancingProcessDetailsDTO: BalancingProcessDetails = {
      name: formValue.balancingProcessName,
      juridicalForm: formValue.balancingProcessJuridicalForm,
      cui: formValue.balancingProcessCui,
      registrationNumber: formValue.balancingProcessRegistrationNumber,
      phoneNumber: formValue.balancingProcessPhoneNumber,
      mobilePhoneNumber: formValue.balancingProcessMobilePhoneNumber,
      fax: formValue.balancingProcessFax,
      email: formValue.balancingProcessEmail,
      hasDelegatedPRE: formValue.balancingProcessHasDelegatedPRE,
      hasOtherPRE: formValue.balancingProcessHasOtherPRE,
      personName: formValue.balancingProcessPersonName,
      personSurname: formValue.balancingProcessPersonSurname,
      personCnp: formValue.balancingProcessPersonCnp,
      preType: formValue.balancingProcessPreType
    };

    const correspondenceAddressDTO: Address = this.isSameAddress ? addressDTO : {
      city: formValue.correspondenceCity,
      extendedAddress: formValue.correspondenceExtendedAddress,
      postalCode: formValue.correspondencePostalCode,
      county: formValue.correspondenceCounty,
      streetNumber: formValue.correspondenceStreetNumber,
      streetName: formValue.correspondenceStreetName,
      block: formValue.correspondenceBlock,
      floor: formValue.correspondenceFloor,
      apartment: formValue.correspondenceApartment
    };
    let creationDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd')

    return {
      id: this.companyId,
      aggregateDTO,
      balancingProcessDetailsDTO,
      addressDTO,
      correspondenceAddressDTO,
      fax: formValue.fax,
      name: formValue.name,
      email: formValue.email,
      creationDate: creationDate,
      legalForm: formValue.legalForm,
      mobileNumber: formValue.mobileNumber,
      phoneNumber: formValue.phoneNumber,
      code: formValue.cui,
      cui: formValue.cui,
      position: formValue.position,
      onrcRegistrationNumber: formValue.onrcRegistrationNumber,
      isProsumer: formValue.isProsumer,
      isSelfSupplier: formValue.isSelfSupplier,
      isAggregate: formValue.isAggregate,
      isElectricalEnergyClient: formValue.isElectricalEnergyClient,
      documents: this.documents
    };
  }

  onDisplayRequiredDocument(): any {
    return {
      'border-red': (!this.documents || this.documents.length === 0),
    };
  }

  errorNotification(message: string): void {
    Swal.fire({
      title: ' ',
      text: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  saveCompanyDetails(): void {

    const invalidControls = Object.entries(this.accountForm.controls).filter(([key, control]) => {
      return !!control.invalid;
    });
    if (!this.accountForm.valid || !this.documents || this.documents.length === 0) {
      this.accountForm.markAllAsTouched();
      console.log('invalidControls', invalidControls);
      this.errorNotification('Nu toate campurile marcate cu steluta rosie au fost completate. Va rugam verificati');
      return;
    }

    const formData: FormData = new FormData();
    formData.append('company', JSON.stringify(this.createDataFromForm()));
    if (this.documents) {
      for (const document of this.documents) {
        if (!document.file) {
          continue;
        }
        formData.append('documents', document.file, document.fileName);
      }
    }

    this.companyDetailsService.addCompanyDetails(formData).subscribe(
      v => {
        this.toastrService.success('Date actualizate cu success.');
        this.router.navigateByUrl('/utilizator/persoana-juridica/lista-companii');
      },
      error => {
        if (error && error.status === 409) {
          Swal.fire({
            title: ' ',
            text: error.error.message,
            customClass: {
              popup: 'popup-z-elevate-24-blue'
            }
          });
        }
      }
    );
  }

  reloadCurrentRoute(): void {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  updateCorrespondenceCounty(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceCounty.setValue(value);
    }
  }

  updateCorrespondenceCity(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceCity.setValue(value);
    }
  }

  updateCorrespondenceStreetName(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceStreetName.setValue(value);
    }
  }

  updateCorrespondenceStreetNumber(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceStreetNumber.setValue(value);
    }
  }

  updateCorrespondenceBlock(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceBlock.setValue(value);
    }
  }

  updateCorrespondenceFloor(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceFloor.setValue(value);
    }
  }

  updateCorrespondenceApartment(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceApartment.setValue(value);
    }
  }

  updateCorrespondenceExtendedAddress(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceExtendedAddress.setValue(value);
    }
  }

  updateCorrespondencePostalCode(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondencePostalCode.setValue(value);
    }
  }

  upload(fileList: FileList): void {
    console.log('upload', fileList);
    if (fileList.length > 0) {
      for (let i = 0; i < fileList.length; i++) {
        if (!this.documentNameExists(fileList.item(i).name)) {
          let document = {
            fileName: fileList.item(i).name,
            fileByteSize: fileList.item(i).size,
            fileType: fileList.item(i).type,
            file: fileList.item(i)
          };
          this.documents.push(document);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.routeDataSub?.unsubscribe();
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  deleteDocument(index: number): void {
    if (this.documents) {
      this.documents.splice(index, 1);
    }
  }

  documentNameExists(fileName: string): boolean {
    return this.documents.some(function (el) {
      return el.fileName === fileName;
    });
  }

}
